module.exports = __webpack_public_path__ + "static/media/newsImage5.b86135c0.svg";